<template>
  <div style="margin: 15px 30px 0">
    <div class="drawer__content">
      <el-form style="margin: 10px" ref="form" :model="form" label-position="top">
        <el-form-item label="优先级" prop="priority" :rules="{ required: true, message: '请选择优先级' }">
          <el-radio-group v-model="form.priority">
            <el-radio v-for="priority in getAllTicketPriority()" :key="priority" :label="priority">
              {{ getTicketPriority(priority) }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="工单类型" prop="category" :rules="{ required: true, message: '请选择工单类型' }">
          <el-radio-group v-model="form.category">
            <el-radio label="Cms">CMS问题</el-radio>
            <el-radio label="Cloud">网站云问题</el-radio>
            <el-radio label="Theme">模板问题</el-radio>
            <el-radio label="Extension">插件问题</el-radio>
            <el-radio label="Other">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问题描述" prop="content" :rules="{ required: true, message: '请输入问题描述' }">
          <el-input type="textarea" :rows="10" v-model="form.content" placeholder="请用一两句话描述您遇到的问题现象"></el-input>
        </el-form-item>
        <el-form-item label="问题截图">
          <el-upload
            :action="uploadUrl"
            :headers="{ Authorization: 'Bearer ' + uploadToken }"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="uploadBefore"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :file-list="fileList"
            multiple
            list-type="picture">
            <el-button type="primary">点击上传</el-button>
            <div class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <div class="drawer__footer">
        <el-button type="primary" @click="btnSubmitClick" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
        <el-button @click="btnCancelClick">取 消</el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import utils from '@/utils';
import api, { ISubmitRequest, IUploadResult } from '@/api/my/tickets';
import { IElForm } from '@/types/element';
import { TicketPriority } from '@/types/enums';
import { auth } from '@/store';

interface IFile {
  name: string;
  url: string;
}

interface IState {
  form: ISubmitRequest;
  loading: boolean;
  uploadToken: string;
  uploadUrl: string;
  fileList: IFile[];
}

export default defineComponent({
  name: 'TicketAdd',
  data() {
    return {
      hostIds: [],
      themeIds: [],
      extensionIds: [],
      form: {
        priority: TicketPriority.Normal,
        category: '',
        resourceId: '',
        content: '',
        fileUrls: [],
      },
      loading: false,
      uploadToken: auth.token,
      uploadUrl: api.getUploadUrl(),
      fileList: [],
    } as IState;
  },
  methods: {
    getAllTicketPriority() {
      return Object.values(TicketPriority);
    },

    getTicketPriority(priority: TicketPriority) {
      return utils.getTicketPriority(priority);
    },

    btnSubmitClick() {
      const form = this.$refs.form as IElForm;
      form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.fileUrls = [];
          for (const file of this.fileList) {
            this.form.fileUrls.push(file.url);
          }
          api.submit(this.form, (res) => {
            if (!res.value) return;
            utils.success('工单提交成功！');
            this.$emit('close', true);
          });
        }
      });
    },

    handleRemove(file: IFile) {
      this.fileList.splice(this.fileList.indexOf(file), 1);
    },

    handlePreview(file: IFile) {
      window.open(file.url);
    },

    uploadBefore(file: {name: string; size: number }) {
      const re = /(\.jpg|\.png)$/i;
      if (!re.exec(file.name)) {
        utils.error('截图只能是图片格式，请选择有效的文件上传!');
        return false;
      }

      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        utils.error('文件大小不能超过 10MB!');
      }
      return isLt10M;
    },

    uploadProgress() {
      utils.loading(true);
    },

    uploadSuccess(res: IUploadResult) {
      this.fileList.push(res);
      utils.loading(false);
    },

    uploadError(err: { message: string }) {
      utils.loading(false);
      const error = JSON.parse(err.message);
      utils.error(error.message);
    },

    btnCancelClick() {
      this.$emit('close', false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      const form = this.$refs.form as IElForm;
      form.resetFields();
      form.clearValidate();
    });
  },
});
</script>
